import { render, staticRenderFns } from "./HasVisiophone.vue?vue&type=template&id=638c20b0&"
import script from "./HasVisiophone.vue?vue&type=script&lang=ts&"
export * from "./HasVisiophone.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports